import styled from "styled-components";

export const Label = styled.label`
  margin: 20px 0 10px;
  display: block;
`;
